import styled, { css } from 'styled-components';
import { inputFullStyles } from '../../utils/forms/inputStyles';
import { theme } from '../../theme';

export const dropdownIndicatorStyles = css`
  --padding-right: ${theme.sizes[9]};

  padding-right: var(--padding-right);
  background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fillRule='evenodd' clipRule='evenodd' d='M4 6L8 10L12 6H4Z' fill='currentColor' /%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position:
    right ${theme.sizes[3]} top 50%,
    0 0;
`;

export const SelectInput = styled.select<any>`
  ${inputFullStyles}
  ${dropdownIndicatorStyles}

  /* Simulate placeholder styles when a disabled option is selected */
  &:has(option:disabled:checked) {
    color: ${theme.colors.neutral.ink.light};
  }
`;
